// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 508) return "static/chunks/508-e03e7d7d8fdaee4c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"18":"0333b85523d26fa5","283":"61998503259f7828","309":"6056d7e3dddde1c0"}[chunkId] + ".js";
};